import axios from 'axios'
import config from '@/config'

const uriNames = config.api.handling.names

const DEFAULT_PARAMS = {
  '$limit': 1000
}
export default {
  create (data) {
    return axios.post(uriNames, data)
  },
  get (params = {}) {
    return axios.get(uriNames, {
      params: {
        ...params,
        ...DEFAULT_PARAMS
      }
    })
  }
}
